(() => {
  const sections = document.querySelectorAll('[data-lfm-video-reels]');
  if (!sections.length) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const cards = section.querySelectorAll('[data-lfm-reel-card]');
    const scroller = section.querySelector('[data-lfm-reels-scroller]');
    const leftArrow = section.querySelector('[data-lfm-scroll-left]');
    const rightArrow = section.querySelector('[data-lfm-scroll-right]');

    const pauseAllExcept = (currentVideo) => {
      cards.forEach((card) => {
        const media = card;
        const video = media.querySelector('.lfm-video-reels__video');
        if (!video || video === currentVideo) return;

        video.pause();
        video.currentTime = 0;
        video.muted = true;
        video.controls = false;
        media.classList.remove('is-playing');
      });
    };

    cards.forEach((card) => {
      const media = card;
      const video = media.querySelector('.lfm-video-reels__video');
      const playButton = media.querySelector('[data-lfm-toggle-play]');

      if (!video || !playButton) return;

      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.controls = false;
      video.preload = 'metadata';

      // Hover preview
      if (!prefersReduced) {
        media.addEventListener('mouseenter', async () => {
          if (media.classList.contains('is-playing')) return;

          try {
            video.currentTime = 0;
            video.muted = true;
            await video.play();
          } catch (error) {
            // silencio
          }
        });

        media.addEventListener('mouseleave', () => {
          if (media.classList.contains('is-playing')) return;

          video.pause();
          video.currentTime = 0;
        });
      }

      // Click en botón play: reproducir inline
      playButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (media.classList.contains('is-playing')) {
          video.pause();
          video.currentTime = 0;
          video.muted = true;
          video.controls = false;
          media.classList.remove('is-playing');
          return;
        }

        pauseAllExcept(video);

        try {
          video.muted = false;
          video.controls = true;
          await video.play();
          media.classList.add('is-playing');
        } catch (error) {
          console.error('No se pudo reproducir el video:', error);
        }
      });

      // Click directo sobre el video también pause/play
      video.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (media.classList.contains('is-playing')) {
          video.pause();
          media.classList.remove('is-playing');
          video.controls = false;
          video.muted = true;
        } else {
          pauseAllExcept(video);

          try {
            video.muted = false;
            video.controls = true;
            await video.play();
            media.classList.add('is-playing');
          } catch (error) {
            console.error('No se pudo reproducir el video:', error);
          }
        }
      });

      video.addEventListener('ended', () => {
        media.classList.remove('is-playing');
        video.currentTime = 0;
        video.muted = true;
        video.controls = false;
      });

      video.addEventListener('pause', () => {
        if (media.classList.contains('is-playing')) {
          media.classList.remove('is-playing');
          video.controls = false;
          video.muted = true;
        }
      });
    });

    // Flechas laterales
    if (scroller && leftArrow && rightArrow) {
      const getScrollAmount = () => {
        const firstCard = scroller.querySelector('.lfm-video-reels__card');
        if (!firstCard) return scroller.clientWidth * 0.85;

        const styles = window.getComputedStyle(scroller);
        const gap = parseFloat(styles.columnGap || styles.gap || 24);
        return firstCard.getBoundingClientRect().width + gap;
      };

      leftArrow.addEventListener('click', () => {
        scroller.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      rightArrow.addEventListener('click', () => {
        scroller.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }
  });
})();